import React, { useState } from "react";
import {
  Box as MuiBox,
  IconButton as MuiIconButton,
  ClickAwayListener as MuiClickAwayListener,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ContextualHelp = ({ helpText, sx }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <MuiClickAwayListener onClickAway={handleTooltipClose}>
      <MuiBox sx={{ ...sx }}>
        <Tooltip
          title={helpText}
          arrow
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          slotProps={{
            popper: {
              disablePortal: true,
            },
            tooltip: {
              sx: {},
            },
          }}
        >
          <MuiIconButton
            size="small"
            sx={{
              padding: "3px",
              border: "1px solid #ccc",
              borderRadius: "100px",
            }}
            onClick={handleTooltipOpen}
          >
            <InfoOutlineIcon
              fontSize="small"
              sx={{ mr: 1, fontSize: "19px" }}
            />
            <KeyboardArrowDownIcon fontSize="small" sx={{ fontSize: "19px" }} />
          </MuiIconButton>
        </Tooltip>
      </MuiBox>
    </MuiClickAwayListener>
  );
};

ContextualHelp.propTypes = {
  helpText: PropTypes.string.isRequired,
};

export default ContextualHelp;
